import { AlertIcon } from '@primer/octicons-react';
import classes from './SelectPanel.module.css.js';
import { clsx } from 'clsx';
import { jsxs, jsx } from 'react/jsx-runtime';
import Octicon from '../Octicon/Octicon.js';
import Text from '../Text/Text.js';

const SelectPanelMessage = ({
  variant,
  title,
  children,
  className
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: clsx(classes.Message, className),
    children: [variant !== 'empty' ? /*#__PURE__*/jsx(Octicon, {
      icon: AlertIcon,
      className: classes.MessageIcon,
      "data-variant": variant
    }) : null, /*#__PURE__*/jsx(Text, {
      className: classes.MessageTitle,
      children: title
    }), /*#__PURE__*/jsx(Text, {
      className: classes.MessageBody,
      children: children
    })]
  });
};
SelectPanelMessage.displayName = "SelectPanelMessage";

export { SelectPanelMessage };
